const HS_CONSENT_GROUP = 'C0002'

function parseActiveGroupsString(s) {
    if (!s || typeof s !== 'string') return []
    return s.split(',').map((g) => g.trim()).filter(Boolean)
}

function handleHubspotConsentUpdate(event) {
    window._hsp = window._hsp || []
    const rawDetail = (event && event.detail) || window.OnetrustActiveGroups || ''
    const consentedGroups = Array.isArray(rawDetail)
        ? rawDetail
        : parseActiveGroupsString(rawDetail)

    if (consentedGroups.includes(HS_CONSENT_GROUP)) {
        window._hsp.push(['grantCookieConsent'])
    } else {
        window._hsp.push(['doNotTrack'])
    }
}

export function initHubspotConsentBridge() {
    if (window.OneTrust && typeof window.OneTrust.OnConsentChanged === 'function') {
        window.OneTrust.OnConsentChanged(handleHubspotConsentUpdate)
        handleHubspotConsentUpdate({ detail: window.OnetrustActiveGroups || '' })
        return
    }

    if (window._onetrustReady) {
        setTimeout(initHubspotConsentBridge, 0)
        return
    }

    window.addEventListener('onetrust-ready', initHubspotConsentBridge, { once: true })
}
